import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UxLayoutHorizontalModule, UxLayoutOverlayPanelComponentModule } from '@eui/components/legacy/layout';
import { UxOrderByPipeModule, UxFilterPipeModule, UxTruncatePipeModule, UxCurrencyPipeModule, UxIsoToCountryPipeModule } from '@eui/components/legacy/common/ux-pipes';
import { UxScrollHandlerDirectiveModule, UxMaxlengthModule, UxTooltipModule, UxAutoResizeModule, UxCollapsibleDirectiveModule, UxHasPermissionDirectiveModule, UxTemplateDirectiveModule, UxSmoothScrollDirectiveModule, UxCleaveModule } from '@eui/components/legacy/common/ux-directives';
import { UxAlertComponentModule } from '@eui/components/legacy/ux-alert';
import { UxDashboardCardComponentModule } from '@eui/components/legacy/ux-dashboard-card';
import { UxTabComponentModule, UxTabsComponentModule } from '@eui/components/legacy/ux-tab';
import { UxTabsBarComponentModule } from '@eui/components/legacy/ux-tabs-bar';
import { UxStaticTabsComponentModule } from '@eui/components/legacy/ux-static-tabs';
import { UxTimelineItemsComponentModule, UxTimelineItemComponentModule } from '@eui/components/legacy/ux-timeline';
import { UxWizardStepComponentModule, UxWizardStepsComponentModule } from '@eui/components/legacy/ux-wizard-step';
import { UxTreeListComponentModule, UxTreeListItemComponentModule } from '@eui/components/legacy/ux-tree-list';
import { UxPanelComponentModule, UxPanelsComponentModule } from '@eui/components/legacy/ux-panel';
import { UxSwitchComponentModule } from '@eui/components/legacy/ux-switch';
import { UxButtonComponentModule } from '@eui/components/legacy/ux-button';
import { UxControlFeedbackComponentModule } from '@eui/components/legacy/ux-control-feedback';
import { UxDropdownButtonComponentModule, UxDropdownButtonItemComponentModule } from '@eui/components/legacy/ux-dropdown-button';
import { UxFieldsetComponentModule } from '@eui/components/legacy/ux-fieldset';
import { UxFileUploadComponentModule, UxMFileUploadComponentModule } from '@eui/components/legacy/ux-file-upload';
import { UxModalComponentModule } from '@eui/components/legacy/ux-modal';
import { UxDashboardButtonsComponentModule, UxDashboardButtonComponentModule } from '@eui/components/legacy/ux-dashboard-button';
import { UxTagComponentModule, UxIconComponentModule, UxIconToggleComponentModule, UxLabelComponentModule } from '@eui/components/legacy/atomic';
import { UxProgressCircleComponentModule } from '@eui/components/legacy/ux-progress-circle';
import { UxTreeComponentModule } from '@eui/components/legacy/ux-tree';
import { UxTimebarComponentModule } from '@eui/components/legacy/ux-timebar';
import { UxBadgeComponentModule } from '@eui/components/legacy/ux-badge';
import { UxButtonGroupComponentModule, UxButtonGroupItemComponentModule } from '@eui/components/legacy/ux-button-group';
import { UxSplitButtonComponentModule } from '@eui/components/legacy/ux-split-button';
import { UxMessageBoxComponentModule } from '@eui/components/legacy/ux-message-box';
import { UxBadgeGroupComponentModule } from '@eui/components/legacy/ux-badge-group';
import { UxOverlayComponentModule } from '@eui/components/legacy/ux-overlay';
import { UxListItemComponentModule, UxListItemsComponentModule } from '@eui/components/legacy/ux-list-item';
import { UxDropdownComponentModule } from '@eui/components/legacy/ux-dropdown';
import { UxDropdownTreeComponentModule } from '@eui/components/legacy/ux-dropdown-tree';
import { UxFieldSearchComponentModule } from '@eui/components/legacy/ux-field-search';
import { UxLoadingIndicatorComponentModule } from '@eui/components/legacy/ux-loading-indicator';
import { UxPopoverComponentModule } from '@eui/components/legacy/ux-popover';
import { UxDiscussionThreadComponentModule, UxDiscussionThreadItemComponentModule } from '@eui/components/legacy/ux-discussion-thread';
import { UxFormControlComponentModule } from '@eui/components/legacy/ux-form-control';
import { UxFormGroupComponentModule } from '@eui/components/legacy/ux-form-group';
import { UxDisableContentComponentModule } from '@eui/components/legacy/ux-disable-content';
import { UxDynamicModalComponentModule } from '@eui/components/legacy/ux-dynamic-modal';
import { UxDynamicMessageBoxComponentModule } from '@eui/components/legacy/ux-dynamic-message-box';
import { UxDynamicPopoverComponentModule } from '@eui/components/legacy/ux-dynamic-popover';
import { UxErrorOutputComponentModule } from '@eui/components/legacy/ux-error-output';
import { UxErrorGroupOutputComponentModule } from '@eui/components/legacy/ux-error-group-output';
import { UxCardComponentModule } from '@eui/components/legacy/ux-card';
import { UxDatepickerComponentModule } from '@eui/components/legacy/ux-datepicker';
import { UxTimepickerComponentModule } from '@eui/components/legacy/ux-timepicker';
import { UxDateRangeSelectorComponentModule } from '@eui/components/legacy/ux-date-range-selector';
import { UxActionBoxComponentModule } from '@eui/components/legacy/ux-action-box';

class UxAllModule {
}
/** @nocollapse */ UxAllModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAllModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxAllModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxAllModule, imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
        UxLayoutHorizontalModule,
        UxLayoutOverlayPanelComponentModule,
        UxOrderByPipeModule,
        UxFilterPipeModule,
        UxTruncatePipeModule,
        UxCurrencyPipeModule,
        UxIsoToCountryPipeModule,
        UxScrollHandlerDirectiveModule,
        UxMaxlengthModule,
        UxTooltipModule,
        UxAutoResizeModule,
        UxCollapsibleDirectiveModule,
        UxHasPermissionDirectiveModule,
        UxTemplateDirectiveModule,
        UxSmoothScrollDirectiveModule,
        UxCleaveModule,
        UxAlertComponentModule,
        UxDashboardCardComponentModule,
        UxDashboardButtonsComponentModule,
        UxDashboardButtonComponentModule,
        UxPanelComponentModule,
        UxPanelsComponentModule,
        UxTabComponentModule,
        UxTabsComponentModule,
        UxTabsBarComponentModule,
        UxStaticTabsComponentModule,
        UxTimelineItemsComponentModule,
        UxTimelineItemComponentModule,
        UxTimepickerComponentModule,
        UxWizardStepComponentModule,
        UxWizardStepsComponentModule,
        UxTreeListComponentModule,
        UxTreeListItemComponentModule,
        UxSwitchComponentModule,
        UxButtonComponentModule,
        UxControlFeedbackComponentModule,
        UxDropdownButtonComponentModule,
        UxDropdownButtonItemComponentModule,
        UxFieldsetComponentModule,
        UxFileUploadComponentModule,
        UxMFileUploadComponentModule,
        UxModalComponentModule,
        UxDynamicModalComponentModule,
        UxDynamicMessageBoxComponentModule,
        UxDynamicPopoverComponentModule,
        UxTagComponentModule,
        UxIconComponentModule,
        UxIconToggleComponentModule,
        UxLabelComponentModule,
        UxProgressCircleComponentModule,
        UxTreeComponentModule,
        UxTimebarComponentModule,
        UxBadgeComponentModule,
        UxButtonGroupComponentModule,
        UxButtonGroupItemComponentModule,
        UxSplitButtonComponentModule,
        UxMessageBoxComponentModule,
        UxBadgeGroupComponentModule,
        UxOverlayComponentModule,
        UxListItemComponentModule,
        UxListItemsComponentModule,
        UxDropdownComponentModule,
        UxDropdownTreeComponentModule,
        UxFieldSearchComponentModule,
        UxLoadingIndicatorComponentModule,
        UxPopoverComponentModule,
        UxDiscussionThreadComponentModule,
        UxDiscussionThreadItemComponentModule,
        UxFormControlComponentModule,
        UxFormGroupComponentModule,
        UxDisableContentComponentModule,
        UxDropdownButtonItemComponentModule,
        UxErrorOutputComponentModule,
        UxErrorGroupOutputComponentModule,
        UxCardComponentModule,
        UxDatepickerComponentModule,
        UxDateRangeSelectorComponentModule,
        UxActionBoxComponentModule], exports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
        UxLayoutHorizontalModule,
        UxLayoutOverlayPanelComponentModule,
        UxOrderByPipeModule,
        UxFilterPipeModule,
        UxTruncatePipeModule,
        UxCurrencyPipeModule,
        UxIsoToCountryPipeModule,
        UxScrollHandlerDirectiveModule,
        UxMaxlengthModule,
        UxTooltipModule,
        UxAutoResizeModule,
        UxCollapsibleDirectiveModule,
        UxHasPermissionDirectiveModule,
        UxSmoothScrollDirectiveModule,
        UxTemplateDirectiveModule,
        UxCleaveModule,
        UxAlertComponentModule,
        UxDashboardCardComponentModule,
        UxDashboardButtonsComponentModule,
        UxDashboardButtonComponentModule,
        UxPanelComponentModule,
        UxPanelsComponentModule,
        UxTabComponentModule,
        UxTabsComponentModule,
        UxTabsBarComponentModule,
        UxStaticTabsComponentModule,
        UxTimelineItemsComponentModule,
        UxTimelineItemComponentModule,
        UxWizardStepComponentModule,
        UxWizardStepsComponentModule,
        UxTreeListComponentModule,
        UxTreeListItemComponentModule,
        UxSwitchComponentModule,
        UxButtonComponentModule,
        UxControlFeedbackComponentModule,
        UxDropdownButtonComponentModule,
        UxDropdownButtonItemComponentModule,
        UxFieldsetComponentModule,
        UxFileUploadComponentModule,
        UxModalComponentModule,
        UxDynamicModalComponentModule,
        UxDynamicMessageBoxComponentModule,
        UxDynamicPopoverComponentModule,
        UxTagComponentModule,
        UxIconComponentModule,
        UxIconToggleComponentModule,
        UxLabelComponentModule,
        UxProgressCircleComponentModule,
        UxTreeComponentModule,
        UxTimebarComponentModule,
        UxBadgeComponentModule,
        UxButtonGroupComponentModule,
        UxButtonGroupItemComponentModule,
        UxSplitButtonComponentModule,
        UxMessageBoxComponentModule,
        UxBadgeGroupComponentModule,
        UxOverlayComponentModule,
        UxListItemComponentModule,
        UxListItemsComponentModule,
        UxDropdownComponentModule,
        UxDropdownTreeComponentModule,
        UxFieldSearchComponentModule,
        UxLoadingIndicatorComponentModule,
        UxPopoverComponentModule,
        UxDiscussionThreadComponentModule,
        UxDiscussionThreadItemComponentModule,
        UxFormControlComponentModule,
        UxFormGroupComponentModule,
        UxDisableContentComponentModule,
        UxDropdownButtonItemComponentModule,
        UxErrorOutputComponentModule,
        UxErrorGroupOutputComponentModule,
        UxCardComponentModule,
        UxDatepickerComponentModule,
        UxTimepickerComponentModule,
        UxDateRangeSelectorComponentModule,
        UxActionBoxComponentModule] });
/** @nocollapse */ UxAllModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAllModule, imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
        UxLayoutHorizontalModule,
        UxLayoutOverlayPanelComponentModule,
        UxOrderByPipeModule,
        UxFilterPipeModule,
        UxTruncatePipeModule,
        UxCurrencyPipeModule,
        UxIsoToCountryPipeModule,
        UxScrollHandlerDirectiveModule,
        UxMaxlengthModule,
        UxTooltipModule,
        UxAutoResizeModule,
        UxCollapsibleDirectiveModule,
        UxHasPermissionDirectiveModule,
        UxTemplateDirectiveModule,
        UxSmoothScrollDirectiveModule,
        UxCleaveModule,
        UxAlertComponentModule,
        UxDashboardCardComponentModule,
        UxDashboardButtonsComponentModule,
        UxDashboardButtonComponentModule,
        UxPanelComponentModule,
        UxPanelsComponentModule,
        UxTabComponentModule,
        UxTabsComponentModule,
        UxTabsBarComponentModule,
        UxStaticTabsComponentModule,
        UxTimelineItemsComponentModule,
        UxTimelineItemComponentModule,
        UxTimepickerComponentModule,
        UxWizardStepComponentModule,
        UxWizardStepsComponentModule,
        UxTreeListComponentModule,
        UxTreeListItemComponentModule,
        UxSwitchComponentModule,
        UxButtonComponentModule,
        UxControlFeedbackComponentModule,
        UxDropdownButtonComponentModule,
        UxDropdownButtonItemComponentModule,
        UxFieldsetComponentModule,
        UxFileUploadComponentModule,
        UxMFileUploadComponentModule,
        UxModalComponentModule,
        UxDynamicModalComponentModule,
        UxDynamicMessageBoxComponentModule,
        UxDynamicPopoverComponentModule,
        UxTagComponentModule,
        UxIconComponentModule,
        UxIconToggleComponentModule,
        UxLabelComponentModule,
        UxProgressCircleComponentModule,
        UxTreeComponentModule,
        UxTimebarComponentModule,
        UxBadgeComponentModule,
        UxButtonGroupComponentModule,
        UxButtonGroupItemComponentModule,
        UxSplitButtonComponentModule,
        UxMessageBoxComponentModule,
        UxBadgeGroupComponentModule,
        UxOverlayComponentModule,
        UxListItemComponentModule,
        UxListItemsComponentModule,
        UxDropdownComponentModule,
        UxDropdownTreeComponentModule,
        UxFieldSearchComponentModule,
        UxLoadingIndicatorComponentModule,
        UxPopoverComponentModule,
        UxDiscussionThreadComponentModule,
        UxDiscussionThreadItemComponentModule,
        UxFormControlComponentModule,
        UxFormGroupComponentModule,
        UxDisableContentComponentModule,
        UxDropdownButtonItemComponentModule,
        UxErrorOutputComponentModule,
        UxErrorGroupOutputComponentModule,
        UxCardComponentModule,
        UxDatepickerComponentModule,
        UxDateRangeSelectorComponentModule,
        UxActionBoxComponentModule, CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
        UxLayoutHorizontalModule,
        UxLayoutOverlayPanelComponentModule,
        UxOrderByPipeModule,
        UxFilterPipeModule,
        UxTruncatePipeModule,
        UxCurrencyPipeModule,
        UxIsoToCountryPipeModule,
        UxScrollHandlerDirectiveModule,
        UxMaxlengthModule,
        UxTooltipModule,
        UxAutoResizeModule,
        UxCollapsibleDirectiveModule,
        UxHasPermissionDirectiveModule,
        UxSmoothScrollDirectiveModule,
        UxTemplateDirectiveModule,
        UxCleaveModule,
        UxAlertComponentModule,
        UxDashboardCardComponentModule,
        UxDashboardButtonsComponentModule,
        UxDashboardButtonComponentModule,
        UxPanelComponentModule,
        UxPanelsComponentModule,
        UxTabComponentModule,
        UxTabsComponentModule,
        UxTabsBarComponentModule,
        UxStaticTabsComponentModule,
        UxTimelineItemsComponentModule,
        UxTimelineItemComponentModule,
        UxWizardStepComponentModule,
        UxWizardStepsComponentModule,
        UxTreeListComponentModule,
        UxTreeListItemComponentModule,
        UxSwitchComponentModule,
        UxButtonComponentModule,
        UxControlFeedbackComponentModule,
        UxDropdownButtonComponentModule,
        UxDropdownButtonItemComponentModule,
        UxFieldsetComponentModule,
        UxFileUploadComponentModule,
        UxModalComponentModule,
        UxDynamicModalComponentModule,
        UxDynamicMessageBoxComponentModule,
        UxDynamicPopoverComponentModule,
        UxTagComponentModule,
        UxIconComponentModule,
        UxIconToggleComponentModule,
        UxLabelComponentModule,
        UxProgressCircleComponentModule,
        UxTreeComponentModule,
        UxTimebarComponentModule,
        UxBadgeComponentModule,
        UxButtonGroupComponentModule,
        UxButtonGroupItemComponentModule,
        UxSplitButtonComponentModule,
        UxMessageBoxComponentModule,
        UxBadgeGroupComponentModule,
        UxOverlayComponentModule,
        UxListItemComponentModule,
        UxListItemsComponentModule,
        UxDropdownComponentModule,
        UxDropdownTreeComponentModule,
        UxFieldSearchComponentModule,
        UxLoadingIndicatorComponentModule,
        UxPopoverComponentModule,
        UxDiscussionThreadComponentModule,
        UxDiscussionThreadItemComponentModule,
        UxFormControlComponentModule,
        UxFormGroupComponentModule,
        UxDisableContentComponentModule,
        UxDropdownButtonItemComponentModule,
        UxErrorOutputComponentModule,
        UxErrorGroupOutputComponentModule,
        UxCardComponentModule,
        UxDatepickerComponentModule,
        UxTimepickerComponentModule,
        UxDateRangeSelectorComponentModule,
        UxActionBoxComponentModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxAllModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
                        UxLayoutHorizontalModule,
                        UxLayoutOverlayPanelComponentModule,
                        UxOrderByPipeModule,
                        UxFilterPipeModule,
                        UxTruncatePipeModule,
                        UxCurrencyPipeModule,
                        UxIsoToCountryPipeModule,
                        UxScrollHandlerDirectiveModule,
                        UxMaxlengthModule,
                        UxTooltipModule,
                        UxAutoResizeModule,
                        UxCollapsibleDirectiveModule,
                        UxHasPermissionDirectiveModule,
                        UxTemplateDirectiveModule,
                        UxSmoothScrollDirectiveModule,
                        UxCleaveModule,
                        UxAlertComponentModule,
                        UxDashboardCardComponentModule,
                        UxDashboardButtonsComponentModule,
                        UxDashboardButtonComponentModule,
                        UxPanelComponentModule,
                        UxPanelsComponentModule,
                        UxTabComponentModule,
                        UxTabsComponentModule,
                        UxTabsBarComponentModule,
                        UxStaticTabsComponentModule,
                        UxTimelineItemsComponentModule,
                        UxTimelineItemComponentModule,
                        UxTimepickerComponentModule,
                        UxWizardStepComponentModule,
                        UxWizardStepsComponentModule,
                        UxTreeListComponentModule,
                        UxTreeListItemComponentModule,
                        UxSwitchComponentModule,
                        UxButtonComponentModule,
                        UxControlFeedbackComponentModule,
                        UxDropdownButtonComponentModule,
                        UxDropdownButtonItemComponentModule,
                        UxFieldsetComponentModule,
                        UxFileUploadComponentModule,
                        UxMFileUploadComponentModule,
                        UxModalComponentModule,
                        UxDynamicModalComponentModule,
                        UxDynamicMessageBoxComponentModule,
                        UxDynamicPopoverComponentModule,
                        UxTagComponentModule,
                        UxIconComponentModule,
                        UxIconToggleComponentModule,
                        UxLabelComponentModule,
                        UxProgressCircleComponentModule,
                        UxTreeComponentModule,
                        UxTimebarComponentModule,
                        UxBadgeComponentModule,
                        UxButtonGroupComponentModule,
                        UxButtonGroupItemComponentModule,
                        UxSplitButtonComponentModule,
                        UxMessageBoxComponentModule,
                        UxBadgeGroupComponentModule,
                        UxOverlayComponentModule,
                        UxListItemComponentModule,
                        UxListItemsComponentModule,
                        UxDropdownComponentModule,
                        UxDropdownTreeComponentModule,
                        UxFieldSearchComponentModule,
                        UxLoadingIndicatorComponentModule,
                        UxPopoverComponentModule,
                        UxDiscussionThreadComponentModule,
                        UxDiscussionThreadItemComponentModule,
                        UxFormControlComponentModule,
                        UxFormGroupComponentModule,
                        UxDisableContentComponentModule,
                        UxDropdownButtonItemComponentModule,
                        UxErrorOutputComponentModule,
                        UxErrorGroupOutputComponentModule,
                        UxCardComponentModule,
                        UxDatepickerComponentModule,
                        UxDateRangeSelectorComponentModule,
                        UxActionBoxComponentModule,
                    ],
                    declarations: [],
                    exports: [
                        CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
                        UxLayoutHorizontalModule,
                        UxLayoutOverlayPanelComponentModule,
                        UxOrderByPipeModule,
                        UxFilterPipeModule,
                        UxTruncatePipeModule,
                        UxCurrencyPipeModule,
                        UxIsoToCountryPipeModule,
                        UxScrollHandlerDirectiveModule,
                        UxMaxlengthModule,
                        UxTooltipModule,
                        UxAutoResizeModule,
                        UxCollapsibleDirectiveModule,
                        UxHasPermissionDirectiveModule,
                        UxSmoothScrollDirectiveModule,
                        UxTemplateDirectiveModule,
                        UxCleaveModule,
                        UxAlertComponentModule,
                        UxDashboardCardComponentModule,
                        UxDashboardButtonsComponentModule,
                        UxDashboardButtonComponentModule,
                        UxPanelComponentModule,
                        UxPanelsComponentModule,
                        UxTabComponentModule,
                        UxTabsComponentModule,
                        UxTabsBarComponentModule,
                        UxStaticTabsComponentModule,
                        UxTimelineItemsComponentModule,
                        UxTimelineItemComponentModule,
                        UxWizardStepComponentModule,
                        UxWizardStepsComponentModule,
                        UxTreeListComponentModule,
                        UxTreeListItemComponentModule,
                        UxSwitchComponentModule,
                        UxButtonComponentModule,
                        UxControlFeedbackComponentModule,
                        UxDropdownButtonComponentModule,
                        UxDropdownButtonItemComponentModule,
                        UxFieldsetComponentModule,
                        UxFileUploadComponentModule,
                        UxModalComponentModule,
                        UxDynamicModalComponentModule,
                        UxDynamicMessageBoxComponentModule,
                        UxDynamicPopoverComponentModule,
                        UxTagComponentModule,
                        UxIconComponentModule,
                        UxIconToggleComponentModule,
                        UxLabelComponentModule,
                        UxProgressCircleComponentModule,
                        UxTreeComponentModule,
                        UxTimebarComponentModule,
                        UxBadgeComponentModule,
                        UxButtonGroupComponentModule,
                        UxButtonGroupItemComponentModule,
                        UxSplitButtonComponentModule,
                        UxMessageBoxComponentModule,
                        UxBadgeGroupComponentModule,
                        UxOverlayComponentModule,
                        UxListItemComponentModule,
                        UxListItemsComponentModule,
                        UxDropdownComponentModule,
                        UxDropdownTreeComponentModule,
                        UxFieldSearchComponentModule,
                        UxLoadingIndicatorComponentModule,
                        UxPopoverComponentModule,
                        UxDiscussionThreadComponentModule,
                        UxDiscussionThreadItemComponentModule,
                        UxFormControlComponentModule,
                        UxFormGroupComponentModule,
                        UxDisableContentComponentModule,
                        UxDropdownButtonItemComponentModule,
                        UxErrorOutputComponentModule,
                        UxErrorGroupOutputComponentModule,
                        UxCardComponentModule,
                        UxDatepickerComponentModule,
                        UxTimepickerComponentModule,
                        UxDateRangeSelectorComponentModule,
                        UxActionBoxComponentModule,
                    ],
                }]
        }] });

/* COMMONS */

/**
 * Generated bundle index. Do not edit.
 */

export { UxAllModule };
